module.exports = __webpack_public_path__ + "static/media/TgMante.48bedbc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/TgMante.svg
// module id = 213
// module chunks = 0